import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaVault } from 'react-icons/fa6';
import EntityManagementScreen from '../common/EntityManagementScreen';
import ParticipantRelations from '../../components/identifierVault/ParticipantRelations.component';
import { VAULT_FIELDS_TO_HIDE, VaultHelpPanel } from './IdentifierVaultScreen';

const participantDisplayName = (p) => {
    if (!p) return '';
    const name = [p.firstName, p.middleName, p.lastName]
        .filter((n) => n && String(n).trim())
        .join(' ')
        .trim();
    if (name) return name;
    return (p.patientIdentifier || p.studyHash || p.nhsNumber || p.chiNumber || '').trim();
};

// /identifier_vault/:participantId — view/edit only (no create route; vault rows are minted on Patient save).
const IdentifierVaultParticipantScreen = () => {
    const { participantId } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <EntityManagementScreen
            entityName="VaultPatient"
            beautifulName={t('Participant')}
            icon={<FaVault size={24} />}
            fieldsToHide={VAULT_FIELDS_TO_HIDE}
            showEntityEditById={participantId}
            showListByDefault={false}
            enableCreate={false}
            onBackClick={() => navigate('/identifier_vault')}
            sectionKicker={t('Participant')}
            sectionTitle={(p) => participantDisplayName(p) || t('Participant')}
            helpContent={<VaultHelpPanel t={t} />}
            renderDetailExtra={(id) => <ParticipantRelations participantId={id} />}
        />
    );
};

export default IdentifierVaultParticipantScreen;
